import * as AppConstants from '../constants/AppConstants'
import UserService from '../services/UserService'

export const login = userDetails => ({
  type: AppConstants.USER_LOGGED_IN,
  payload: userDetails
})

export const logout = () => async dispatch => {
  dispatch({ type: AppConstants.USER_LOGGING_OUT })
  try {
    await UserService.logout()
    dispatch({ type: AppConstants.USER_LOGGED_OUT })
  } catch (err) {
    dispatch({ type: AppConstants.USER_LOGOUT_ERROR })
  }
}

export const signupComplete = userDetails => ({
  type: AppConstants.USER_LOGGED_IN,
  payload: userDetails
})



// WEBPACK FOOTER //
// ./src/actions/UserActions.js